/**
 * Defaults to Tote mode. User can switch between:
 *   TOTE    -> ToteScannerView (scans tote barcode -> tote items flow)
 *   PRODUCT -> ProductScannerView (scans product barcode -> classification flow)
 */

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ToteScannerView from "./ToteScannerView";
import ProductScannerView from "./ProductScannerView";
import { ScanMode } from "src/types/classificationTypes";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { setLastScanMode } from "src/store/userSlice";

interface ScannerPageLocationState {
  title?: string;
  mode?: string;
}

const ScannerPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { title, mode } = (location.state as ScannerPageLocationState) ?? {};
  const lastScanMode = useAppSelector((state) => state.user.lastScanMode);

  const [activeMode, setActiveMode] = useState<ScanMode>(
    mode === "PRODUCT" ? ScanMode.PRODUCT : lastScanMode,
  );

  const handleModeChange = (newMode: ScanMode) => {
    setActiveMode(newMode);
    dispatch(setLastScanMode(newMode));
  };

  if (activeMode === ScanMode.TOTE) {
    return <ToteScannerView activeMode={activeMode} onModeChange={handleModeChange} />;
  }

  return (
    <ProductScannerView activeMode={activeMode} onModeChange={handleModeChange} title={title} />
  );
};

export default ScannerPage;
